import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { CallsProtocolI } from '@interfaces/protocol.interface';

@Injectable({
  providedIn: 'root',
})
export class CallsProtocolHttpService {
  private slug_url = 'protocol/calls';
  private baseUrl = environment.OMNISMART_API_PROTOCOL;
  constructor(private readonly http: HttpClient) {}
  post() {
    return this.http.post<CallsProtocolI>(`${this.baseUrl}${this.slug_url}`, {});
  }
}
